import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { AuthShell } from "@/pages/auth/AuthShell";
import { api, apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function VerifyEmail() {
  const [sp] = useSearchParams();
  const token = sp.get("token");
  const [status, setStatus] = useState(token ? "loading" : "notoken");
  const [msg, setMsg] = useState("");

  useEffect(() => {
    if (!token) return;
    api.post("/auth/verify-email", { token })
      .then(() => setStatus("ok"))
      .catch((e) => { setStatus("error"); setMsg(apiError(e)); });
  }, [token]);

  return (
    <AuthShell title="Verifica email">
      <div className="text-center" data-testid="verify-email-status">
        {status === "loading" && <><Loader2 className="mx-auto h-10 w-10 animate-spin text-[#2DD4BF]" /><p className="mt-4 text-[#CBD5E1]">Verifica in corso…</p></>}
        {status === "ok" && <><CheckCircle2 className="mx-auto h-12 w-12 text-[#10B981]" /><p className="mt-4 text-[#CBD5E1]">Email verificata con successo! Ora puoi pubblicare carte e proporre scambi.</p><Button asChild className="mt-6 bg-[#7C3AED] hover:bg-[#6D28D9]"><Link to="/dashboard">Vai alla dashboard</Link></Button></>}
        {status === "error" && <><XCircle className="mx-auto h-12 w-12 text-[#EF4444]" /><p className="mt-4 text-[#CBD5E1]">{msg}</p><p className="mt-2 text-sm text-[#94A3B8]">Puoi richiedere una nuova email di verifica dalla tua dashboard.</p><Button asChild className="mt-6 bg-[#7C3AED] hover:bg-[#6D28D9]"><Link to="/dashboard">Vai alla dashboard</Link></Button></>}
        {status === "notoken" && <p className="text-[#CBD5E1]">Link di verifica non valido. Apri il link ricevuto via email.</p>}
      </div>
    </AuthShell>
  );
}
